// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1TI4y","inputWrap":"styles_inputWrap__Pfqg7","input":"styles_input__2xGJe"};